<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-card>
        <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
          <span>Employee CTO Card ({{ name }})</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 900px" class="my-4">
          <v-container>
            <v-row>
              <v-col cols="12" md="8" class="flex-items">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <!-- <v-col cols="6"
                ><div class="d-flex">
                  <div style="width:20%" class="text-subtitle-1">Name:</div>

                  <div style="width:80%" class="text-subtitle-1">
                    {{ name }}
                  </div>
                </div>
              </v-col> -->
              <v-col cols="12" v-if="tab == 1">
                <table class="table mt-5 mx-2">
                  <thead>
                    <tr>
                      <th
                        align="left"
                        class="text-caption px-4 font-weight-bold py-2"
                      >
                        Date Earned
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                      >
                        No. of Hours<br />
                        Earned COCs
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                      >
                        Equivalent No. of Hours<br />
                        for CTO
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                      >
                        Date of CTO
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                      >
                        Used COCs<br />(in hours)
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                      >
                        Remaining COCs <br />(in hours)
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                      >
                        Remarks
                      </th>
                      <th
                        v-if="toEdit"
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        rowspan="2"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="hasCTOCardData">
                    <tr v-for="(item, i) in cto_card_data" :key="i">
                      <td align="left" class="text-caption pa-2">
                        {{ item.date_earned }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        <!-- {{ item.coc_hours }} -->
                        {{
                          item.coc_hours != null && item.coc_hours != ""
                            ? take2Decimal(item.coc_hours)
                            : ""
                        }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        <!-- {{ item.cto_hours }} -->
                        {{
                          item.cto_hours != null && item.cto_hours != ""
                            ? take2Decimal(item.cto_hours)
                            : ""
                        }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.cto_date }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.cto_used }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ take2Decimal(item.cto_rem) }}
                        <!-- {{ item.cto_rem }} -->
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.remarks }}
                      </td>
                      <td
                        v-if="toEdit"
                        align="center"
                        class="text-caption py-2"
                      >
                        <div
                          v-if="item.leave_id"
                          style="width: 100px"
                          class="text-wrap text-justify"
                        >
                          <v-btn
                            x-small
                            class="white--text"
                            @click="confirmRestore(item.leave_id)"
                            color="#6DB249"
                          >
                            restore
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="!hasCTOCardData">
                    <tr>
                      <td
                        colspan="7"
                        align="center"
                        class="text-caption pa-4 grey--text"
                      >
                        No data available
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" v-else-if="tab == 2">
                <v-data-table
                  :headers="headers1"
                  :items="itemsData"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.date_restored`]="{ item }">
                    {{ formatDate(item.date_restored) }}
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <div class="text-no-wrap">
                      <v-btn
                        x-small
                        color="green"
                        class="mx-1"
                        outlined
                        @click="View(item)"
                      >
                        <v-icon size="14">mdi-eye</v-icon>
                        View
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions class="pa-5" v-if="viewFrom != 'audit'">
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            v-if="!toEdit"
            @click="toEdit = !toEdit"
            color="#6DB249"
            v-show="tab == 1"
          >
            Edit
          </v-btn>

          <v-btn
            class="white--text"
            v-if="!openDeduct"
            @click="deductDialog()"
            color="#6DB249"
            v-show="!toEdit"
          >
            Deduct Expired
          </v-btn>

          <v-btn
            v-if="!openDeduct"
            color="red"
            outlined
            @click="closeD()"
            v-show="!toEdit"
          >
            Close
          </v-btn>

          <v-btn
            v-if="openDeduct || toEdit"
            color="red"
            outlined
            @click="toEdit ? (toEdit = false) : cancelDeduct()"
          >
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="leaveDialog"
      eager
      persistent
      scrollable
      max-width="1000"
    >
      <v-form
        ref="RestoreFormref"
        enctype="multipart/form-data"
        @submit.prevent
      >
        <v-card>
          <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
            <span>Applied Date's</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeLeave()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="max-height: 900px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-data-table :headers="headers" :items="leave_credit">
                    <template v-slot:[`item.credit_date_for`]="{ item }">
                      {{ formatDate(item.credit_date_for) }}
                    </template>

                    <template v-slot:[`item.action`]="{ item }">
                      <div class="text-no-wrap">
                        <v-btn
                          v-if="ifMorethanOne()"
                          x-small
                          color="green"
                          class="mx-1"
                          outlined
                          @click="restore(item)"
                        >
                          <v-icon size="14">mdi-recycle</v-icon>
                          Restore
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    outlined
                    accept="application/pdf"
                    v-model="restoredFile"
                    label="File Attachment"
                    :rule="[formRules.required]"
                    dense
                  ></v-file-input>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    :rules="[formRules.required]"
                    v-model="restoreRemarks"
                    dense
                    outlined
                    required
                    label="Remarks"
                    color="#93CB5B"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-8 py-4">
            <v-btn color="red" outlined @click="closeLeave()"> Cancel </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              class="white--text"
              :loading="submitBtnLoading"
              :disabled="submitBtnLoading"
              @click="restoreCTO()"
              v-if="dates_restored.length == 0"
            >
              Restore CTO
            </v-btn>

            <v-btn
              color="green"
              class="white--text"
              :loading="submitBtnLoading"
              :disabled="submitBtnLoading"
              @click="apply()"
              v-if="dates_restored.length > 0"
            >
              apply
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="openDeductDialog" persistent max-width="700">
      <v-card color="white">
        <v-card-title dark class="dialog-header">
          Deduct Expired CTO
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 800px">
          <v-form ref="deductFormRef" @submit.prevent>
            <v-container>
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-text-field
                    :rules="[formRules.required]"
                    dense
                    outlined
                    v-model="cto_left"
                    required
                    label="CTO credits"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    dense
                    outlined
                    class="rounded-lg"
                    color="#6DB249"
                    :rules="[formRules.required]"
                    v-model="exp_remarks"
                    required
                    label="Remarks"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="openDeductDialog = false">
            Close
          </v-btn>

          <v-btn
            color="green"
            class="white--text"
            :loading="submitBtnLoading"
            :disabled="submitBtnLoading"
            @click="add_expire()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Restored Dialog-->
    <v-dialog
      v-model="restoredDialog"
      eager
      persistent
      scrollable
      max-width="1000"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
          <span>Restored Leave Credits</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeRestoreDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 900px" class="my-4">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  readonly
                  :rules="[formRules.required]"
                  v-model="inclusive_dates"
                  dense
                  outlined
                  required
                  label="Applied Leave Restoration Date"
                  color="#93CB5B"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="number"
                  readonly
                  :rules="[formRules.required]"
                  v-model="credits_restored"
                  dense
                  outlined
                  required
                  label="Hours Restored"
                  color="#93CB5B"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="getRestoredFile()"
                  block
                  color="green"
                  class="white--text mx-1 px-6"
                  elevation="2"
                >
                  View Attached File
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  :rules="[formRules.required]"
                  v-model="remarks"
                  dense
                  readonly
                  outlined
                  required
                  label="Remarks"
                  color="#93CB5B"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-8 py-4">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="closeRestoreDialog()">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <RestoredFileToVIewDialog :data="fileToView" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
    viewFrom: null,
  },
  components: {
    RestoredFileToVIewDialog: () =>
      import("../Views/RestoredFileToVIewDialog.vue"),
  },
  data() {
    return {
      fileToView: null,
      credits_restored: null,
      restoredDialog: false,
      itemsData: [],
      inclusive_dates: null,
      leaveDialog: false,
      leave: null,
      leave_credit: [],
      toEdit: false,
      dialog: false,
      submitBtnLoading: false,
      confirmDialog: false,
      openDeductDialog: false,
      cto_left: null,
      remarks: null,
      exp_remarks: null,
      restoreRemarks: null,
      restoredFile: null,
      openDeduct: null,
      itemToRestore: null,
      hasCTOCardData: null,
      cto_card_data: [],
      id: null,
      empID: null,
      name: null,
      filter: null,
      dates_restored: [],
      restored_leave_id: [],
      filename: null,
      activeTab: { id: 1, name: "Leave Credits" },
      tab: 1,
      tabList: [
        { id: 1, name: "Leave Credits" },
        { id: 2, name: "Restored" },
      ],
      headers: [
        {
          text: "Date",
          value: "credit_date_for",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Hours",
          value: "credit",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
          valign: "center",
          sortable: false,
        },
      ],
      headers1: [
        {
          text: "Restored By",
          value: "name",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Credit Type",
          value: "credit_type",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Date Restored",
          value: "date_restored",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          align: "end",
          valign: "center",
          sortable: false,
        },
      ],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("CTO", data);
        this.name = data.name;
        this.empID = data.empID;
        this.filter = this.$store.getters.getFilterSelected;
        this.loadCTOCard();
      },
      deep: true,
    },
  },

  methods: {
    ifMorethanOne() {
      return this.leave_credit.length > 1;
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.loadCTOCard();
    },
    computeAnnual(value) {
      var annual = 0;
      for (let index = 0; index < 12; index++) {
        annual += parseFloat(value);
      }
      return annual;
    },

    deductDialog() {
      let crd = this.formatNumberValue(
        this.cto_card_data[this.cto_card_data.length - 1].cto_rem,
        2,
      );
      this.cto_left = crd;
      this.openDeduct = true;
      this.openDeductDialog = true;
    },

    cancelDeduct() {
      this.openDeduct = false;
      this.openDeductDialog = false;
    },

    loadCTOCard() {
      if (this.tab == 1) {
        this.axiosCall(
          "/leave-credits/getCTOCardByEmpIDV2/" +
            this.empID +
            "/" +
            this.filter,
          "GET",
        ).then((res) => {
          if (res) {
            this.hasCTOCardData = res.data.length > 0;
            this.cto_card_data = res.data;
            console.log("cto_card_data", this.cto_card_data);
          }
        });
      } else {
        this.hasCTOCardData = null;
        this.cto_card_data = [];
        this.axiosCall(
          "/leave-credits/getRestoredLeaveCreditsForCTO/" + this.empID,
          "GET",
        ).then((res) => {
          if (res) {
            console.log(res.data);
            this.itemsData = res.data;
          }
        });
      }
    },

    add_expire() {
      if (this.$refs.deductFormRef.validate()) {
        if (parseFloat(this.cto_left) > 0) {
          let data = {
            empID: this.empID,
            cto_left: this.cto_left,
            remarks: this.exp_remarks,
          };
          this.axiosCall("/leave-credits/deductExpireCTO", "POST", data).then(
            (res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.openDeductDialog = false;
                this.openDeduct = false;
                this.loadCTOCard();
              } else if (res.data.status == 400) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            },
          );
        }
      }
    },
    confirmRestore(leaveID) {
      this.itemToRestore = leaveID;
      this.axiosCall("/leave-credits/getForRestoreCTO/" + leaveID, "GET").then(
        (res) => {
          if (res) {
            this.leave_credit = res.data;
            this.axiosCall("/leaves/" + this.itemToRestore, "GET").then(
              (res) => {
                if (res) {
                  this.leave = res.data;
                  this.leaveDialog = true;
                }
              },
            );
          }
        },
      );
    },
    apply() {
      if (this.$refs.RestoreFormref.validate()) {
        if (this.restoredFile == null) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Please upload file attachment to restore leave credit!";
        }
        let file =
          this.restoredFile.name.split(".")[
            this.restoredFile.name.split(".").length - 1
          ];
        if (file !== "pdf") {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please upload file in pdf format!";
        } else {
          const fd = new FormData();
          fd.append("file", this.restoredFile);
          let data = {
            leaveID: this.leave.id,
            remarks: this.restoreRemarks,
            leave_cred_ID: this.restored_leave_id,
            dates_restored: this.dates_restored,
          };
          fd.append("body", JSON.stringify(data));
          this.axiosCall(
            "/leaves/restore-credit-specific-for-cto",
            "POST",
            fd,
          ).then((res) => {
            if (res) {
              this.confirmDialog = false;
              this.toEdit = false;
              this.restoredFile = null;
              this.restoreRemarks = null;
              this.loadCTOCard();
              this.closeLeave();
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          });
        }
      }
    },
    restore(item) {
      this.dates_restored.push(item.credit_date_for);
      this.restored_leave_id.push(item.id);

      const index = this.leave_credit.findIndex(
        (credit) => credit.id == item.id,
      );

      if (index !== -1) {
        this.leave_credit.splice(index, 1);
      }
    },
    restoreCTO() {
      if (this.$refs.RestoreFormref.validate()) {
        if (this.restoredFile == null) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Please upload file attachment to restore leave credit!";
        }
        let file =
          this.restoredFile.name.split(".")[
            this.restoredFile.name.split(".").length - 1
          ];
        if (file !== "pdf") {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please upload file in pdf format!";
        } else {
          const fd = new FormData();
          fd.append("file", this.restoredFile);
          let data = {
            leaveID: this.leave.id,
            remarks: this.restoreRemarks,
          };
          fd.append("body", JSON.stringify(data));
          this.axiosCall("/leaves/restore-credit-for-cto", "POST", fd).then(
            (res) => {
              if (res) {
                this.confirmDialog = false;
                this.toEdit = false;
                this.restoredFile = null;
                this.restoreRemarks = null;
                this.loadCTOCard();
                this.closeLeave();
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            },
          );
        }
      }
    },
    View(item) {
      console.log("Leave", item);
      this.credits_restored = item.credit;
      this.remarks = item.remarks != null ? item.remarks : "No remarks added";
      this.filename = item.filename != null ? item.filename : "";
      this.restoredDialog = true;
      this.inclusive_dates = this.formatDate(item.credit_date_for);
    },
    getRestoredFile() {
      if (this.itemsData[0].lraID != null) {
        let data = null;
        setTimeout(() => {
          data = null;
        }, 100);
        data = {
          filedesc: "Restored File",
          filename: this.filename,
        };
        this.fileToView = data;
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "No file Uploaded";
      }
    },

    closeD() {
      this.dialog = false;
      this.openDeductDialog = false;
      this.openDeduct = false;
      this.activeTab = this.tabList[1];
      this.tab = 1;
      this.eventHub.$emit("closeViewCTOCardDialog", false);
    },
    closeLeave() {
      this.leave = null;
      this.leave_credit = [];
      this.dates_restored = [];
      this.restored_leave_id = [];
      this.leaveDialog = false;
    },
    closeRestoreDialog() {
      this.credits_restored = null;
      this.remarks = null;
      this.filename = null;
      this.restoredDialog = false;
      this.inclusive_dates = null;
    },
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
}
table,
td {
  border-bottom: 1px solid rgb(206, 202, 202);
}
tr:first-child th:first-child {
  border-top-left-radius: 10px;
}
tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

/* tr:nth-child(2) th:first-child {
  border-top-left-radius: none;
}
tr:nth-child(2) th:last-child {
  border-top-right-radius: none;
} */

tr td:first-child {
  border-left: 1px solid rgb(206, 202, 202);
}
tr td:last-child {
  border-right: 1px solid rgb(206, 202, 202);
}
</style>
